import {
  createContext,
  useState,
  useContext,
  useEffect
} from 'react';
import {
  getNotifications,
  stopNotification
} from '../service/serviceChat/chatService';


const keyNotificationStorage = '@UCB-MyNotification';
const NotificationContext = createContext();


export const NotificationProvider = ({ children }) => {

  const [soundNotification, setSoundNotification] = useState(false);
  const [contNewChats, setContNewChats] = useState(0);
  const [contMyChats, setContMyChats] = useState(0);
  const [contOpenChats, setContOpenChats] = useState(0);
  const [contMyChatsClose, setContMyChatsClose] = useState(0);
  const [contMyGroup, setContMyGroup] = useState(0);
  const [myChatsNotification, setMyChatsNotification] = useState([]);


  // useEffect(() => {
  //   getNotifications(onAlertNotification);
  // }, []);
  // async function onAlertNotification(messageID, message) {
  //   const stopPromise = stopNotification(messageID);
  //   const isSameClient = sessionStorage.getItem('@UCB-Customer') 
  //   && JSON.parse(sessionStorage.getItem('@UCB-Customer'))?.client_name === message?.from;
  //   if (isSameClient) {
  //     return;
  //   }
  //   const sound = new Audio(soundUrl);
  //   sound.play();
  //   await stopPromise;
  // }

  function onSoundNotification(status) {
    setSoundNotification(!status);
  };

  function startNotificationMyChats(status, idChat) {
    setMyChatsNotification(oldValue => {
      const index = oldValue.indexOf(idChat)
      if (!status) {
        if (index !== -1) oldValue.splice(index, 1)
      } else if (index === -1) oldValue.push(idChat)
      return [...oldValue]
    });
  };

  function handlerContNewChats(newChats) {
    setContNewChats(newChats)
  };
  function handlerContMyChats(myChats) {
    setContMyChats(myChats)
  };
  function handlerContOpenChats(openChats) {
    setContOpenChats(openChats)
  };
  function handlerContMyGroup(groupChats) {
    setContMyGroup(groupChats)
  };
  function handlerMyChatsClose(myChatsClose) {
    setContMyChatsClose(myChatsClose)
  };

  const notificationValues = {
    contNewChats,
    contMyChats,
    contOpenChats,
    contMyGroup,
    contMyChatsClose,
    myChatsNotification,
    soundNotification,
    handlerContNewChats,
    handlerContMyChats,
    handlerContOpenChats,
    handlerMyChatsClose,
    handlerContMyGroup,
    startNotificationMyChats,
    onSoundNotification,
  };

  return (
    <NotificationContext.Provider value={notificationValues}>
      {children}
    </NotificationContext.Provider>
  );
};

export function useNotification() {
  const context = useContext(NotificationContext);
  return context;
}

export const Notification = () => JSON.parse(sessionStorage.getItem(keyNotificationStorage));